export default __webpack_public_path__ + "static/media/ic_logo_text_white.5064c6ab.png";